import { DEFAULT_CURRENCY, useBounceGlobalValues, useTranslation } from "@bounce/i18n"
import { Button, HeroContainer, grayBlurDataUrl, imgixCroppedHeroImage } from "@bounce/web-components"

import { Breadcrumbs } from "@/components/Generic/Breadcrumbs/Breadcrumbs"
import { Marquee } from "@/components/LuggageStorage/Marquee/Marquee"
import { SearchBar } from "@/components/LuggageStorage/SearchBar/SearchBar"
import type { AggregateRating } from "@/libs/bounce/types"
import type { Breadcrumb } from "@/types"

import background from "@/assets/img/default_hero_1.png"

type HeroProps = {
  aggregateRating: AggregateRating
}

export const Hero = ({ aggregateRating }: HeroProps) => {
  const [t] = useTranslation("marketing-ls-cities")
  const bounceGlobals = useBounceGlobalValues()

  const breadcrumbs: Breadcrumb[] = [
    {
      id: "home",
      name: t("page.cities.breadcrumbs.home", "Home"),
      href: "/",
    },
    {
      id: "cities",
      name: t("page.cities.breadcrumbs.allCitiesV2", "Cities"),
      href: "/cities",
    },
  ]

  return (
    <>
      <HeroContainer
        image={background}
        placeholder="blur"
        fallbackBlurDataURL={grayBlurDataUrl}
        imgixParams={{ ...imgixCroppedHeroImage }}
        className="w-full">
        <Breadcrumbs breadcrumbs={breadcrumbs} className="pb-5" />
        <h1 className="title1 mb-3 mt-1 break-words md:mb-3.5 lg:mb-5">
          {t("page.cities.allCitiesV2", "Store your luggage all over the world")}
        </h1>
        <p className="subtitle">
          {t(
            "page.cities.allCitiesDescription3",
            "Bounce is in more than {{numCities}} cities including many not listed below. Search any location here",
            { numCities: bounceGlobals.numCities },
          )}
        </p>
        <SearchBar
          from="Cities"
          className="mt-8 md:mt-12 md:max-w-[512px]"
          button={
            <Button className="w-full max-w-full md:w-fit">
              {t("page.cities.hero.searchBarCta", "Find closest locations")}
            </Button>
          }
        />
      </HeroContainer>
      <Marquee aggregateRating={aggregateRating} currency={DEFAULT_CURRENCY} />
    </>
  )
}
